import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Exp-Candidates/DriveTable/Drivefilter/Style/style'

const DriveRoleFilter = ({ driveStatus, setDrivestatus }) => {
  const statusOptions = [
    {
      label: 'Confirmed',
      value: 'CONFIRMED',
    },
    {
      label: 'Pending',
      value: 'PENDING',
    },
    {
      label: 'Rescheduled',
      value: 'RESCHEDULE_REQUESTED',
    },
    {
      label: 'Cancelled',
      value: 'CANCELLED',
    },
  ]
  return (
    <Wrapper column>
      <FilterCheckBoxComp
        value={driveStatus}
        options={statusOptions}
        onChange={values => setDrivestatus([values[values?.length - 1]])}
      />
    </Wrapper>
  )
}

export default DriveRoleFilter
